











































































import L from 'leaflet'
import {Component, Vue, Watch} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import Mappa from "@/components/Mappa.vue";
import WorkerAnnouncement from "@/components/worker/WorkerAnnouncement.vue";
import {workerIsCompatible} from "@/utils";
import WorkerAnnouncements from "@/components/worker/WorkerAnnouncements.vue";
import {debounce} from "vee-validate/dist/types/utils";
import EventBus from "@/EventBus";

@Component({
    components: {
        WorkerAnnouncements,
        WorkerAnnouncement,
        Mappa
    },
    computed: {
        ...mapGetters({
            user: 'user',
            profile: 'profile',
            isWorker: 'isWorker',
            allAnnouncements: 'allAnnouncements'
        })
    },
    name: "WorkerDashboard"
})
export default class WorkerDashboard extends Vue {
    private user?: any;
    private profile?: any;
    private showing_action_id:string = '';

    private allAnnouncements?: any[];

    private tab_index: number = 0;
    private tabsOffset: number[] = [0,0,0];

    get tabIndex(){
        return this.tab_index;
    }

    set tabIndex(val:number){
        this.showAction = '';
        this.tab_index = val;
        EventBus.$emit('ca:menu_close');
        EventBus.$emit('cw:menu_close');
        EventBus.$emit('wa:menu_close');
    }

    get showAction(){
        return this.showing_action_id;
    }

    set showAction(val:string){
        this.showing_action_id = val

    }

    get compatibleAnnouncements() {
        return (this.allAnnouncements as any[]).filter((announce: any) => {
            return workerIsCompatible(this.profile, announce, announce.company);
        })
    }

    get starredAnnouncementsIds() {
        return this.profile?.starredAnnouncements || [];
    }

    get starredAnnouncements() {
        return (this.allAnnouncements as any[]).filter(item => {
            return this.starredAnnouncementsIds.indexOf(item.id) > -1
        })
    }

    private deactivated(){
        // @ts-ignore
        this.tabsOffset = [...document.getElementsByClassName('tab-pane')].map((el: any)=>{
            return el.scrollTop;
        });
    }

    private activated(){
        // @ts-ignore
        [...document.getElementsByClassName('tab-pane')].forEach((el: any, index:  number)=>{
            el.scrollTop = this.tabsOffset[index];
        });
    }

    private updated() {
        this.$nextTick(() => {
            if(this.$refs.com_ann) (this.$refs.com_ann as any).invalidateMap()
            if(this.$refs.all_ann) (this.$refs.all_ann as any).invalidateMap()
        })
    }

}

